Pre<template>
  <div class="text-center px-4 pb-8" style="height: 100%">
    <v-form ref="form" v-model="dataValid">

      <v-row style="background-color: white" class="rounded-lg mb-2">
        <v-col>
          <div class="basic--text">
            <v-autocomplete class="mx-10 mt-5" :label="'Course of study'" :items="programmes" item-text="name"
              item-value="id" :disabled="!canEdit || isUtme" v-model="obj.programmeId" required
              :rules="textRules"></v-autocomplete>
          </div>
        </v-col>
      </v-row>

      <v-row style="background-color: white" class="rounded-lg mb-2">
        <v-col>
          <div class="mt-3 mx-10" >
            <v-checkbox required :rules="textRules"
                        :disabled="(getApplicantFee != null && getApplicantFee.cleared) || !canEdit || isUtme" v-model="declaration"
                        :value="!canEdit" label="I hereby declare that information given in this form are
                                to the best of my knowledge checked and correctly provided"></v-checkbox>

          </div>
        </v-col>
      </v-row>
    </v-form>
    <v-card-actions class="mt-6">
      <v-btn color="basic" class="white--text" @click="$emit('back')" width="10em" depressed>{{  noHeader ? 'Back' : 'Previous' }}</v-btn>
      <v-spacer></v-spacer>
      <v-btn color="primaryLight" depressed @click="saveData" width="10em" :disabled="!dataValid || (photoUploaded === false && !noHeader) || !canEdit"
        v-if="canEdit"><v-icon>mdi-content-save</v-icon>{{  noHeader ? 'Save' : 'Proceed' }}</v-btn>
      <v-btn color="info" depressed @click="success" v-if="getUser.programme != null" width="10em">Skip</v-btn>
    </v-card-actions>
    <loading-dialog :show="loading"></loading-dialog>
    <message-box :show="messageShow" :message="message" :type="messageType"
      v-on:close-message="messageShow = !messageShow"></message-box>
    <profile-picture-upload :show="showUploadPicture" v-on:close="showUploadPicture = !showUploadPicture"
      :user="getUser" v-on:uploaded="profilePictureUploaded"></profile-picture-upload>
  </div>
</template>


<script>
import { mapGetters } from "vuex";
import Defaults from "@/shared/Defaults";
import LoadingDialog from "@ui/components/LoadingDialog";
import MessageBox from "@ui/components/MessageBox";
import ValidationRules from "@/shared/ValidationRules";
import Api from "@/main/api";
import ErrorResolver from "@/shared/ErrorResolver";
import ProfilePictureUpload from "@/components/ProfilePictureUpload";
import StudentStatus from "@/shared/StudentStatus";

export default {
  name: "ProgrammeAndPassport",
  props: {
    noHeader: Boolean
  },
  components: {
    ProfilePictureUpload,
    MessageBox,
    LoadingDialog,
  },

  data: () => ({
    obj: {},
    showUploadPicture: false,
    image: '',
    messageShow: false,
    loading: false,
    message: '',
    messageType: '',
    dataValid: true,
    textRules: ValidationRules.textRules,
    declaration: null,
    photoUploaded: false,
    programmes: [],
    modeOfEntries: [],
    hidePhoto: false,
  }),

  methods: {
    success() {
      this.$emit("success")
    },

    profilePictureUploaded() {
      // this two lines are to detach the image back to the dom. thos makes the image to update
      // dont know why it's not updating without the lines
      this.hidePhoto = true
      this.image = null

      this.photoUploaded = true

      // attachaes bak the photo
      setTimeout(this.reloadPhoto, 1000)
    },

    reloadPhoto() {
      this.image = Defaults.api + '/profile-picture/fetch?user=' + this.getUser.userId;
      this.hidePhoto = false
    },

    check() {
      this.loading = true;
      Api.applicants.nextToProgrammeUpdate(this.getUser.id).then((res) => {
        this.loading = false;
        this.$store.commit('setCurrentUser', res.data);

      }).catch((err) => ErrorResolver.checkErrors(this, err))
        .finally(() => this.loading = false)
    },

    loadProgrammes() {
      this.loading = true
      Api.programmes.allAvailable(this.getUser.admission.session.programmeType.id)
        .then(res => this.programmes = res.data)
        .catch(err => ErrorResolver.checkErrors(this, err))
        .finally(() => this.loading = false)
    },

    loadModeOfEntries() {
      if (this.getUser != null) {
        this.modeOfEntries = []
        Api.system.modeOfEntries(this.getUser.yearOfAdmission.programmeType.id)
          .then(res => this.modeOfEntries = res.data)
          .catch(err => ErrorResolver.checkErrors(this, err))
          .finally(() => this.loading = false)
      }
    },

    saveData() {
      this.loading = true
      Api.applicants.programmeUpdate(this.getUser.id, this.obj)
        .then((res) => {
          this.message = 'Academic details updated'
          this.messageType = 'success'
          this.messageShow = true
          // check for applicant ID Change
          if(this.getUser.userId !== res.data.userId){
            this.message = 'You have a new ID!!! Check the dashboard for it'
            this.messageType = 'success'
            this.messageShow = true

            this.$store.commit("setCurrentUser", res.data);
          }

          this.success()
        }).catch(err => ErrorResolver.checkErrors(this, err))
        .finally(() => this.loading = false)
    }
  },

  computed: {
    ...mapGetters(['getUser', 'getApplicantFee']),
    canEdit: function () {
      // status still not upto application complete
      return this.getUser != null && (StudentStatus[this.getUser.studentStatus].value <= StudentStatus.APPLICATION_PENDING.value)
    },

    isUtme: function () {
      return this.getUser != null && this.getUser.admission.applicationType.autoLoadUtme
    }
  },

  watch: {
    getUser: function (val) {
      if (val != null) {
        if (this.getUser.programme != null) {
          // this.success()
          // return
          this.obj.programmeId = this.getUser.programme.id
        }
        this.image = Defaults.api + '/profile-picture/fetch?user=' + val.userId;
        // mode of entries
        this.loadModeOfEntries()
      }
    }
  },

  created() {
    if (this.getUser != null) {
      this.image = Defaults.api + '/profile-picture/fetch?user=' + this.getUser.userId;
    }

    // load data
    if (this.getUser != null) {
      // load mode of entries
      this.loadModeOfEntries()
      // already uploaded
      if (this.getUser.programme != null) {
        this.obj.programmeId = this.getUser.programme.id
        this.declaration = true
      }


      this.loadProgrammes(); //load programmes
      this.check();
    }
    this.noHeader && this.$emit('update-title', "Programme")
  }
}
</script>


<style scoped>
.v-text-field >>> .v-input__slot::before  { border-color: #ECBD44 !important; border-width: .01em; border-radius: .006em; }
</style>
